(() => {
  if (customElements.get('pclan-top-dropdown')) return;
  customElements.define('pclan-top-dropdown', class extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => this.init());
    }
    init() {
      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.panel = this.querySelector('.pc-top-panel');
      if (!this.details || !this.summary || !this.panel) return;
      this.controller?.abort();
      this.controller = new AbortController();
      const on = (node, type, fn) => node.addEventListener(type, fn, { signal: this.controller.signal });
      const close = () => { this.details.open = false; };
      on(this, 'pointerenter', () => {
        clearTimeout(this.timer);
        if (this.dataset.trigger === 'hover' && matchMedia('(hover: hover)').matches) this.details.open = true;
      });
      on(this, 'pointerleave', () => {
        this.timer = setTimeout(() => { if (!this.contains(document.activeElement)) close(); }, 220);
      });
      on(this.details, 'toggle', () => {
        if (this.details.open) {
          document.querySelectorAll('pclan-top-dropdown details[open], pclan-mega-menu details[open]').forEach(d => { if (d !== this.details) d.open = false; });
          this.position();
        }
      });
      on(document, 'pointerdown', e => { if (!this.contains(e.target)) close(); });
      on(document, 'keydown', e => {
        if (e.key === 'Escape' && this.details.open) { close(); this.summary.focus(); }
      });
      on(this, 'focusout', () => queueMicrotask(() => { if (!this.contains(document.activeElement)) close(); }));
      on(this.summary, 'keydown', e => {
        if (e.key === 'ArrowDown') { e.preventDefault(); this.details.open = true; this.panel.querySelector('a')?.focus(); }
      });
      on(document, 'toggle', e => {
        if (e.target.open && e.target.closest?.('pclan-mega-menu')) close();
      });
      // Toggle does not bubble; observe the main disclosure directly.
      document.querySelectorAll('pclan-mega-menu details').forEach(d => on(d, 'toggle', () => { if (d.open) close(); }));
      on(window, 'resize', () => { if (innerWidth < 1000) close(); else if (this.details.open) this.position(); });
      on(window, 'scroll', () => { if (this.details.open) this.position(); });
      on(document, 'shopify:block:select', e => {
        if (e.target.contains(this) && innerWidth >= 1000) this.details.open = true;
      });
    }
    position() {
      this.style.setProperty('--pc-top-shift', '0px');
      const rect = this.panel.getBoundingClientRect();
      const shift = Math.max(16 - rect.left, Math.min(0, innerWidth - 16 - rect.right));
      this.style.setProperty('--pc-top-shift', `${shift}px`);
      this.style.setProperty('--pc-top-height', `${Math.max(0, innerHeight - this.summary.getBoundingClientRect().bottom - 16)}px`);
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      clearTimeout(this.timer);
      this.controller?.abort();
    }
  });
})();
